import { withStyles } from '@material-ui/core/styles';
import StyledToolTip from '../../../../../../common/StyledToolTip';

const styles = () => ({
  container: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

const DriverBreakRenderer = (params) => {
  if (params.value) {
    const tooltip = params.value.map((date, index) => (
      <span key={index}>
        {date}
        <br />
      </span>
    ));
    return (
      <StyledToolTip title={tooltip}>
        <div className={params.classes.container}>{params.value.join(', ')}</div>
      </StyledToolTip>
    );
  }
  return null;
};

export default withStyles(styles)(DriverBreakRenderer);
